var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _rect2, _path10, _polygon2, _path11, _polygon3, _polygon4, _polygon5, _path12, _path13, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpBannerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.k{fill:none;}.b,.e{fill:#3c3c46;}.b,.c,.d,.e,.f,.g,.i,.j{fill-rule:evenodd;}.b{opacity:0.15;}.c,.i{fill:#89d9fb;}.c,.d,.j,.k{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;}.c,.j{stroke-width:2px;}.d,.f{fill:#fff;}.d,.k{stroke-width:2px;}.g,.h{fill:#3ca4ef;}.j{fill:#ffefe0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-banner-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.57,111.81a2,2,0,1,1-2,2,2,2,0,0,1,2-2ZM113,46.13H13.57v74.67H122.45a11,11,0,0,0,11-11V45.16a11,11,0,0,0-11-11H113V46.13ZM41.57,111.81a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm-100-60.65a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2A2,2,0,0,1,101.55,51.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M126.43,30.16a11,11,0,0,1-11,11H6.57v74.67H115.46a11,11,0,0,0,11-11V30.16Zm-111.85,16a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm-80,60.65a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2,2,2,0,0,1,2-2Zm20,0a2,2,0,1,1-2,2A2,2,0,0,1,114.55,106.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.35,59.16h0a5.31,5.31,0,0,0-10.51-.63h-.18a4.29,4.29,0,0,0-4.1,3h-.25a2.77,2.77,0,0,0,0,5.54h15.06a4,4,0,0,0,0-7.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M97.14,64.6a2.1,2.1,0,0,0-2.79-2.34,3.85,3.85,0,0,0-7.08,2.08c0,.1,0,.2,0,.3a2.37,2.37,0,0,0,.58,4.66h8.88a2.37,2.37,0,0,0,.4-4.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M103.9,98.14h-1.72L90.39,80.45,88.9,73.77a1.07,1.07,0,0,0-2.1,0l-.22,1L76.9,60.22a3.37,3.37,0,0,0-5.6,0l-5.22,7.83-.64-1a3.37,3.37,0,0,0-5.6,0L52.16,78.61l-1.08-4.85a1.07,1.07,0,0,0-2.1,0l-3.2,14.42-6.64,10H37.42a1.07,1.07,0,1,0,0,2.15H103.9a1.07,1.07,0,1,0,0-2.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M61.62,68.29a1.22,1.22,0,0,1,2,0l4,6L65,77a.07.07,0,0,1-.1,0L63.4,75.53a1.07,1.07,0,0,0-1.52,0L58.2,79.21l-.26-.92a1.07,1.07,0,0,0-1.58-.63l-.59-.59Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M73.09,61.41a1.22,1.22,0,0,1,2,0l4.48,6.72-3.15,3.15a.07.07,0,0,1-.1,0l-3.2-3.2a1.07,1.07,0,0,0-1.52,0L68.31,71.4,67.37,70Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "86.78 98.14 86.14 98.14 84.51 95.7 86.78 95.7 86.78 98.14"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M88.93,98.14V95.7h3.51a1.07,1.07,0,0,0,1-1.31l-1.81-8.14L99.6,98.14H88.93Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M58,98.14V95.7h3.51a1.07,1.07,0,0,0,1-1.37L58.88,81.57l3.76-3.76.72.72a2.22,2.22,0,0,0,3.14,0l2.39-2.39,14.66,22Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 51.11,
    y: 95.7,
    width: 4.73,
    height: 2.44
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M49,98.14H41.72L44.49,94l-.09.4a1.07,1.07,0,0,0,1,1.31H49v2.44Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "54.55 78.89 55.45 79.79 53.74 85.75 52.8 81.52 54.55 78.89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M85.94,77.65l-.65,2.91-1.13-1.7a1.07,1.07,0,0,0-1.79,1.19l2.27,3.41L82.57,92.8,69.52,73.22l2.86-2.86,2.44,2.44a2.22,2.22,0,0,0,3.14,0L80.81,70Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "50.03 78.95 53.28 93.56 46.79 93.56 50.03 78.95"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "60.07 93.56 55.48 93.56 54.72 90.15 56.91 82.5 60.07 93.56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "i",
    points: "87.85 78.95 91.1 93.56 84.61 93.56 87.85 78.95"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M126.43,104.84c0-9.47-13.23-5.63-20.42-2.35V44.41l9.45-2.86c6.06-1.84,11,.5,11,5.21v58.08ZM113,46.18a2.68,2.68,0,0,0-2,2.16c0,.86.9,1.28,2,.95a2.68,2.68,0,0,0,2-2.16c0-.86-.9-1.28-2-.95Zm0,47.19a2.68,2.68,0,0,0-2,2.16c0,.86.9,1.28,2,.95a2.68,2.68,0,0,0,2-2.16C115,93.46,114.11,93,113,93.37Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M126.43,104.84a11,11,0,0,0-11-11H106V19.19h9.45a11,11,0,0,1,11,11v74.67ZM113,24.19a2,2,0,1,0,2,2,2,2,0,0,0-2-2Zm0,60.67a2,2,0,1,0,2,2A2,2,0,0,0,113,84.87Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 85.77,
    x2: 28.02,
    y2: 85.77
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 91.53,
    x2: 36.4,
    y2: 91.53
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 31.02,
    y1: 85.77,
    x2: 36.4,
    y2: 85.77
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 97.29,
    x2: 23.97,
    y2: 97.29
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 28.34,
    y1: 97.29,
    x2: 31.69,
    y2: 97.29
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 62.55,
    x2: 28.02,
    y2: 62.55
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 68.31,
    x2: 36.4,
    y2: 68.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 80.03,
    x2: 32.85,
    y2: 80.03
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 29.05,
    y1: 74.07,
    x2: 32.4,
    y2: 74.07
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 32.02,
    y1: 62.55,
    x2: 41.3,
    y2: 62.55
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 17.98,
    y1: 74.07,
    x2: 23.97,
    y2: 74.07
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpBannerIcon);
export default __webpack_public_path__ + "static/media/CP-banner-icon.ae800231cec0b49ae9c3ef41541af16b.svg";
export { ForwardRef as ReactComponent };